import { useEffect, useState } from 'react';

interface IFetchParameter {
  dependencies?: any[];
  isStartLoad?: boolean;
}

export const useFetch = <T>(
  fetch: () => Promise<T> | undefined,
  { dependencies = [], isStartLoad = true }: IFetchParameter = {}
) => {
  const [response, setResponse] = useState<T>();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const requestDatabase = async () => {
      setIsLoading(true);
      try {
        const fetchData = await fetch();
        setResponse(fetchData);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
        setIsLoading(false);
      }
    };
    if (isStartLoad) {
      requestDatabase();
    }
  }, [...dependencies, isStartLoad]);

  return <const>[response, isLoading];
};

export const useCanceledFetch = <T>(
  fetch: () => Promise<T>,
  { dependencies = [], isStartLoad = true }: IFetchParameter = {}
) => {
  const [response, setResponse] = useState<T>();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let isCanceled = false;

    const requestDatabase = async () => {
      setIsLoading(true);
      try {
        const fetchData = await fetch();
        if (!isCanceled) {
          setResponse(fetchData);
        }
        setIsLoading(false);
      } catch (e) {
        console.error(e);
        setIsLoading(false);
      }
    };
    if (isStartLoad) {
      requestDatabase();
    }
    return () => {
      isCanceled = true;
    };
  }, [...dependencies, isStartLoad]);

  return <const>[response, isLoading];
};
